<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content style="min-width: 420px; padding-top: 8px;">
    <div *ngFor="let item of data.items"
         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px"
         style="margin-bottom: 14px;">
        <mat-icon [style.color]="item.passed ? '#4caf50' : '#f44336'" style="flex-shrink: 0;">
            {{ item.passed ? 'check_circle' : 'cancel' }}
        </mat-icon>
        <span>{{ item.message }}</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <button *ngIf="data.allPassed" mat-flat-button color="primary" [mat-dialog-close]="true">{{ actionText }}</button>
</mat-dialog-actions>
